export class AContact {
  nickname: string;
  quan_pin: string;
  py_initial: string;
  contact_label_ids: string;

  imgflag: number;
  avatar_url1: string;
  avatar_url2: string;

  create_time: number;
  update_time: number;

  member_count: number;

  constructor(contact) {
    this.nickname = contact.nickname;
    this.quan_pin = contact.quan_pin;
    this.py_initial = contact.py_initial;
    this.contact_label_ids = contact.contact_label_ids;
    this.imgflag = contact.imgflag;
    this.avatar_url1 = contact.avatar_url1;
    this.avatar_url2 = contact.avatar_url2;
    this.create_time = contact.create_time;
    this.update_time = contact.update_time;
    this.member_count = contact.member_count;
  }
}
export class Member {
  avatar_url: string;
  be_at_count: number;
  chatroomname: string;
  client_id: number;
  create_time: number;
  effect_count: number;
  img_lastupdatetime: number;
  invitation_count: number;
  nickname: string;
  red_package_count: number;
  run_hour: number;
  sex: number;
  speak_count: number;
  update_time: number;
  username: string;
  is_kicked: number;
  constructor(content: any) {
    this.create_time = content.create_time * 1000;

    this.sex = 0;

    this.effect_count = content.effect_count || 0;
    this.invitation_count = content.invitation_count || 0;
    this.be_at_count = content.be_at_count || 0;
    this.speak_count = content.speak_count || 0;
    this.red_package_count = content.red_package_count;

    this.client_id = content.client_id;
    this.img_lastupdatetime = content.img_lastupdatetime;
    this.username = content.username;

    this.avatar_url = content.avatar_url;
    this.nickname = content.nickname || '路人甲';

    this.is_kicked = content.is_kicked || 0;

    this.update_time = content.update_time * 1000;
  }
}

const vitalityConfig = ['低', '中', '高'];
export class AChatroom {
  active_count: number;
  at_count: number;
  avatar_url: string;
  chatroomname: string;
  chatroomnotice_publish_time: number;
  create_time: number;
  female_count: number;
  in_count: number;
  male_count: number;
  member_count: number;
  modifytime: number;
  nickname: string;
  out_count: number;
  run_hour: number;
  speak_count: number;
  update_time: number;
  chatroom_id: number;

  vitality_count: number;
  invo_count: number;
  memberchange_count: number;
  is_work: number;

  constructor(content: any = {}) {
    this.nickname =
      content.nickname ||
      content.chatroom_nickname ||
      content.nickname_default ||
      '一个微信群';
    this.active_count = content.active_count || 0;
    this.at_count = content.at_count || 0;
    this.avatar_url = content.avatar_url || null;
    this.chatroomname = content.chatroomname || null;
    this.chatroomnotice_publish_time =
      content.chatroomnotice_publish_time || null;
    this.create_time = content.create_time || null;
    this.female_count = content.female_count || 0;
    this.in_count = content.in_count || 0;
    this.male_count = content.male_count || 0;
    this.member_count = content.member_count || 0;
    this.modifytime = content.modifytime || null;
    this.out_count = content.out_count || 0;
    this.run_hour = content.run_hour || null;
    this.speak_count = content.speak_count || 0;
    this.update_time = content.update_time || null;
    this.chatroom_id = content.chatroom_id;
    this.vitality_count = content.vitality_count;
    this.invo_count = content.invo_count || 0;
    this.memberchange_count = content.memberchange_count;
    this.is_work = content.is_work || null;
  }

  get active_rate() {
    return (
      (this.member_count
        ? (this.active_count / this.member_count).toFixed(2)
        : 0) + '%'
    );
  }

  get invo_string() {
    return this.invo_count.toFixed(1) + '%';
  }

  get vitality_string() {
    return this.vitality_count > 0 && this.vitality_count < 4
      ? vitalityConfig[this.vitality_count - 1]
      : '未知';
  }
}

export class Wechat {
  wechat_id: number;
  nick_name: number;
  avatar_url: string;
  alias: string;

  sex: string;
  province: string;
  city: string;
  country: string;

  phone: string;

  create_time: number;
  bot_id: number;

  constructor(wechat: any) {
    this.wechat_id = wechat.wechat_id;
    this.nick_name = wechat.nick_name;
    this.avatar_url = wechat.avatar_url;
    this.alias = wechat.alias;
    this.sex = wechat.sex;
    this.province = wechat.province;
    this.city = wechat.city;
    this.country = wechat.country;
    this.phone = wechat.phone;
    this.create_time = wechat.create_time;
    this.bot_id = wechat.bot_id;
  }
}



// WEBPACK FOOTER //
// ./src/class/ana-chatroom.ts